import { Box } from "@mui/material";
import { motion } from "motion/react";
import { Accept } from "react-dropzone";
import { Dropzone, DropzoneProps, DropzoneText } from "~/components/dropzone";
import { fadeInOut } from "~/lib/animations";

/* 
This component defaults to allowing .pem uploads
as this is our most common usage
*/

const defaultInputs = {
  fileType: ".pem",
  accept: {
    "application/x-x509-ca-cert": [".pem"],
    "application/x-x509-user-cert": [".pem"],
    "application/x-pkcs12": [".pem"],
    "application/x-pem-file": [".pem"],
  },
};

export const HostedIntegrationDropzoneUpload = ({
  onDropAccepted,
  fileType = defaultInputs.fileType,
  accept = defaultInputs.accept,
}: {
  onDropAccepted: DropzoneProps["onDropAccepted"];
  fileType?: string;
  accept?: Accept;
}) => {
  return (
    <Box component={motion.div} {...fadeInOut}>
      <Dropzone
        className="mondoo-dropzone-area"
        accept={accept}
        multiple={false}
        showAlerts={["error"]}
        onDropAccepted={onDropAccepted}
      >
        <DropzoneText>Drag and drop your {fileType} file here.</DropzoneText>
      </Dropzone>
    </Box>
  );
};
